import {
  Box,
  Button,
  CircularProgress,
  Grid,
  Typography,
} from "@mui/material";
//import MoreVertIcon from "@mui/icons-material/MoreVert";
//import EditIcon from "@mui/icons-material/Edit";
//import DeleteIcon from "@mui/icons-material/Delete";
import React, { useState, useEffect } from "react";
//import AddIcon from "@mui/icons-material/Add";
import moment from "moment";
import EditEvent from "./edit_event";
import DeletePopup from "../shared/delete_popup";
import AccessLocalStorage from "../../services/localStorage";
import { getApiUrl } from "../../services/api_service";
import ViewEvent from "./view_event";
import { button, carejourneytabcontainer, carejourneytabheading, eventDateTime, eventDetails, eventsPadding, eventTitle, pcolor } from "../../style2";

export default function Schoolevents() {

  const rowsPerPageValue = 4;
  const [schoolevents, setSchoolevents] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(rowsPerPageValue);
  const [viewMore, setViewMore] = useState(false);

  const [anchorEls, setAnchorEls] = useState([]);
  const [anchorPosition, setAnchorPosition] = useState(null);

  const ls = new AccessLocalStorage();
  const [openEditSchoolevent, setOpenEditSchoolevent] = useState(false);
  const [openViewSchoolevent, setOpenViewSchoolevent] = useState(false);
  const [openAddSchoolevent, setOpenAddSchoolevent] = useState(false);
  const [openDeletePopup, setOpenDeletePopup] = useState(false);

  const [selectedSchoolevent, setSelectedSchoolevent] = useState([]);

  const handleViewMore = () => {
    viewMore ? setViewMore(false) : setViewMore(true);
    viewMore
      ? setRowsPerPage(rowsPerPageValue)
      : setRowsPerPage(schoolevents.length);
  };

  const handleMenuClick = (event, index) => {
    const newAnchorEls = [...anchorEls];
    newAnchorEls[index] = event.currentTarget;
    setAnchorEls(newAnchorEls);
    const { left, top } = event.currentTarget.getBoundingClientRect();
    setAnchorPosition({ left, top });
  };
  const handleMenuClose = (index) => {
    const newAnchorEls = [...anchorEls];
    newAnchorEls[index] = null;
    setAnchorEls(newAnchorEls);
    setAnchorPosition(null);
  };
  const handleClickOpenEditSchoolevent = (selectedSchoolevent, index) => {
    setSelectedSchoolevent(selectedSchoolevent);
    setOpenEditSchoolevent(true);
    //console.log("event edit id:", selectedSchoolevent.id);
    handleMenuClose(index); // to close the menu after opening the edit popup
  };
  const handleClickOpenViewSchoolevent = (selectedSchoolevent) => {
    setSelectedSchoolevent(selectedSchoolevent);
    setOpenViewSchoolevent(true);
    //console.log(selectedSchoolevent);
  };
  const handleClickAddSchoolevent = () => {
    setOpenAddSchoolevent(true);
  };
  const handleClickCloseSchoolevent = () => {
    setOpenEditSchoolevent(false);
    setOpenViewSchoolevent(false);
    setOpenAddSchoolevent(false);
    setSelectedSchoolevent(""); // reset the selected event so the edit dialog will contain new data
  };

  const handleClickDeleteSchoolevent = (id, index) => {
    handleMenuClose(index);
    setOpenDeletePopup(true);
    setSchoolevents(
      schoolevents.filter((schoolevent) => schoolevent.id !== id)
    );
    viewMore
      ? setRowsPerPage(rowsPerPageValue)
      : setRowsPerPage(schoolevents.length);
  };

  const handleClickCloseDeletePopup = () => {
    setOpenDeletePopup(false);
  };
  // const getRandomColor = () => {
  //   const letters = '0123456789ABCDEF';
  //   let color = '#';
  //   for (let i = 0; i < 6; i++) {
  //     color += letters[Math.floor(Math.random() * 16)];
  //   }
  //   return color;
  // };
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const authTokens = localStorage.getItem("authTokens");
    let token;

    if (authTokens) {
      const parsedAuthTokens = JSON.parse(authTokens);
      token = parsedAuthTokens?.accessToken;
    }
    if (!token) {
      setError("Unauthorized. No token available.");
      setLoading(false);
      return;
    }

    fetch(
      `${getApiUrl()}${process.env.REACT_APP_GET_SCHOOLEVENTS
      }/${ls.getCurrentPatientId()}/${"FD25B1B5-6A99-49A3-9D0C-3D1C5F404C2A"}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
      .then((response) => response.json())
      .then((data) => {
        //console.log(data);
        setSchoolevents(data);
      })
      .catch((err) => {
        setError(err.message || "An error occurred.");
        setSchoolevents([]);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  return (
    <Box sx={{...eventsPadding, position: "relative", padding: "0px" }}>
      <Grid container>
        <Grid item xs={11}>
          <Typography sx={carejourneytabheading}>School events</Typography>
        </Grid>
        {loading ? <Grid item xs={1}><CircularProgress /></Grid> : null}
      </Grid>
      <Box sx={carejourneytabcontainer}>
        {schoolevents != null && schoolevents.length > 0 ? schoolevents.slice(0, rowsPerPage).map((schoolevent, index) => {
          return (
            <Grid container direction="row" alignItems="flex-start" key={schoolevent.id}>
              <Grid item xs={3} sx={{...eventDateTime, backgroundColor: "#FAE6EC" }} >
                <div onClick={() => handleClickOpenViewSchoolevent(schoolevent)} style={{ cursor: "pointer", textAlign: "center" }}>
                  <Typography  sx={{...eventTitle, color: pcolor }}>
                    {moment(schoolevent.startDate).format("DD.MM.YYYY")}
                  </Typography>
                  <Typography sx={{ fontSize: "14px", color: pcolor }}>
                    {moment(schoolevent.startDate).format("h:mm A")}
                  </Typography>
                </div>
              </Grid>
              <Grid container item xs={9} alignItems="flex-start" justifyContent="space-between"
                sx={{...eventDetails, backgroundColor: "#FAE6EC" }}>
                <Grid item xs={7} sm={9} md={10}>
                  <div onClick={() => handleClickOpenViewSchoolevent(schoolevent)} style={{ cursor: "pointer" }}>
                    <Typography sx={{...eventTitle, color: pcolor }}>
                      {schoolevent.title != null ? schoolevent.title.length > 50 ?
                        schoolevent.title.substring(0, 50) + "..." : schoolevent.title : null}</Typography>
                    <Typography sx={{ color: "#535353", fontSize: "14px" }}>
                      {schoolevent.description !== null ? schoolevent.description.length <= 50
                        ? schoolevent.description
                        : schoolevent.description.substring(0, 50) + "..." : null}
                    </Typography>
                  </div>
                </Grid>
                {/* <Grid item>
                    <IconButton
                      id={`basic-button-${index}`}
                      aria-controls={`basic-menu-${index}`}
                      onClick={(event) => handleMenuClick(event, index)}
                    >
                      <MoreVertIcon />
                    </IconButton>
                    <Menu
                      id={`basic-menu-${index}`}
                      anchorEl={anchorEls}
                      MenuListProps={{
                        "aria-labelledby": `basic-button-${index}`,
                      }}
                      open={Boolean(anchorEls[index])}
                      onClose={() => handleMenuClose(index)}
                      anchorPosition={anchorPosition}
                      anchorReference="anchorPosition"
                    >
                      <MenuItem
                        onClick={() =>
                          handleClickOpenEditSchoolevent(schoolevent, index)
                        }
                        disableRipple
                      >
                        <EditIcon />
                        <Box m={1} />
                        Edit
                      </MenuItem>
                      <MenuItem
                        onClick={() =>
                          handleClickDeleteSchoolevent(schoolevent.id, index)
                        }
                        disableRipple
                      >
                        <DeleteIcon />
                        <Box m={1} />
                        Delete
                      </MenuItem>
                    </Menu>
                  </Grid> */}
              </Grid>
            </Grid>
          );
        }) : loading ? null : <Box>No School Events</Box>}
      </Box>
      <Box m={3} />
      <Grid container sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
        <Grid item>
          {!viewMore && schoolevents.length > rowsPerPageValue ? (
            <Button sx={button} onClick={handleViewMore}>
              Show More
            </Button>
          ) : (
            <Box m={4} />
          )}
        </Grid>
      </Grid>
      <EditEvent
        open={openEditSchoolevent}
        handleClose={handleClickCloseSchoolevent}
        eventType={"Schoolevent"}
        eventData={selectedSchoolevent}
      />
      {/* <EditEvent open={openViewSchoolevent} handleClose={handleClickCloseSchoolevent} eventType={"School event"} eventData={selectedSchoolevent} disabled={true} /> */}
      <ViewEvent open={openViewSchoolevent} handleClose={handleClickCloseSchoolevent} eventType={"School event"} eventData={selectedSchoolevent} />
      <EditEvent
        open={openAddSchoolevent}
        handleClose={handleClickCloseSchoolevent}
        eventType={"Schoolevent"}
        eventData={selectedSchoolevent}
      />
      <DeletePopup
        open={openDeletePopup}
        handleClose={handleClickCloseDeletePopup}
      />
    </Box>
  );
}
